module.exports = __webpack_public_path__ + "img/img25.e77c8973.png";